import { useState, createContext, useEffect } from 'react';
import { enqueueSnackbar } from 'notistack';
import axiosInstance from '../utils/axios';

const UserContext = createContext({});

function UserProvider({ children }) {
  const [user, setUser] = useState(null);

  const logout = () => {
    axiosInstance.get("/account/logout").then(() => setUser(null)).catch(() => enqueueSnackbar('Logout failed', { variant: 'error' }));
  }

  useEffect(() => {
    axiosInstance.get("/account/currentuser").then(res => setUser(res.data?.user)).catch(() => { });
  }, []);

  const admin = user?.roles?.includes("Admin");

  const isInRole = (role) => admin || user?.roles?.includes(role);

  return <UserContext.Provider value={{ user, setUser, logout, admin, isInRole }}>{children}</UserContext.Provider>
}

export { UserContext, UserProvider };